<script setup lang="ts">
import SelectSimple from '@/components/common/selects/SelectSimple.vue'

const modelValue = defineModel<string>()
</script>

<template>
  <SelectSimple
    v-model="modelValue"
    :options="[
      { id: 'all', value: '', label: 'Tous' },
      { id: 'yes', value: true.toString(), label: 'Oui' },
      { id: 'no', value: false.toString(), label: 'Non' },
    ]"
    label="Filtrer par Forecast"
  />
</template>
